import { render, staticRenderFns } from "./viewTasks.vue?vue&type=template&id=7d059b72&scoped=true"
import script from "./viewTasks.vue?vue&type=script&lang=js"
export * from "./viewTasks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d059b72",
  null
  
)

export default component.exports